import { useFlipperQuery } from "lcm-iot-commons";
import LegalRoutesIndia from "./LegalRoutesIndia";
import LegalRoutes from "./LegalRoutes";

export default function LegalRoutesSwitcher() {
  const { data: flipper } = useFlipperQuery();
  const showTermsVersion2025 = flipper?.showTermsVersion2025;

  if (showTermsVersion2025) {
    return <LegalRoutesIndia />;
  }
  return <LegalRoutes />;
}
